module.exports = __webpack_public_path__ + "static/media/avatar-0.621aa1dd.png";